import OapTechDetails from './code/Scripts/components/OapTechDetails.vue';

export default {
  components: {
    OapTechDetails,
  },
};
